import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=2a0ba6ad&scoped=true"
import script from "./Swatch.vue?vue&type=script&lang=ts"
export * from "./Swatch.vue?vue&type=script&lang=ts"
import style0 from "./Swatch.vue?vue&type=style&index=0&id=2a0ba6ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ba6ad",
  null
  
)

export default component.exports